<app-common-modal-form
  header="Queue Organisation for Processing"
  icon="ic-external-link-20"
  confirmText="Publish"
  closeText="Cancel"
  [isInvalid]="!orgId"
  [isLoading]="isLoading()"
  (close)="close()"
  (confirm)="publish()"
>
  <div class="form-group">
    <app-autocomplete
      label="Organisation"
      placeholder="Select Organisation"
      [disabled]="isLoading()"
      [valuePrimitive]="true"
      [options]="organisations"
      [ngModelOptions]="{standalone: true}"
      [(ngModel)]="orgId"
    />
  </div>

  <div class="form-group">
    <app-select
      label="Mailbox"
      placeholder="Select Mailbox"
      [isDisabled]="isLoading()"
      [valuePrimitive]="true"
      [options]="mailboxes"
      [ngModelOptions]="{standalone: true}"
      [(ngModel)]="useSecondary"
    />
  </div>
</app-common-modal-form>
